import { Component, OnInit } from '@angular/core';
import { LocationService } from '../service/location.service';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { UtilService } from '../service/util.service';
import { ToastService } from '../service/toast.service';
import { Constants } from '../constants/constants';

@Component({
  selector: 'app-location-settings',
  templateUrl: './location-settings.component.html',
  styleUrls: ['./location-settings.component.scss']
})
export class LocationSettingsComponent implements OnInit {

  locations: any = [];
  selectedLocation: any = {};
  defaultLocationSelected: boolean = false;
  facilityList: any = [];
  locationSettings: any = {};
  locationSettingsCopy: any = {};
  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService) { }

  ngOnInit() {
    // this.locations = this.locationData.getLocations();
    this.selectedLocation = { address: { name: "Select Location" } };
    this.getFleetLocationList();
    this.getLocationSettings();
    this.selectedLocation = this.locations[0] != null ? this.locations[0] : { address: { name: "Select Location" } };
  }

  getFleetLocationList() {
    this.utilService.showSpinner();
    this.apiService.getFleetLocationList().then((data) => {
      this.utilService.hideSpinner();
      this.locations = data;
      console.log("Fleet locations from API::", this.locations);
      // this.facilityList = [];
      // data.forEach(element => {
      //   if(element.type == "FACILITY")
      //     this.facilityList.push(element);
      // });
      if (this.locations && this.locations.length > 0)
        this.selectedLocation.address.name = this.locations[0].address.name;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getFleetLocationList();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  onDefaultLocationSelected(index: number) {
    this.selectedLocation = this.locations[index];
    console.log("selected location id : ", this.locations[index].id);
    this.locationSettings.defaultLocationId = this.locations[index].id;
  }

  onGeofenceSettingsChange() {
    this.locationSettings.automaticGefoence = !this.locationSettings.automaticGefoence;
  }

  onDefaultVehicleLocationSelectionChange() {
    // this.defaultLocationSelected = !this.defaultLocationSelected;
    this.locationSettings.enableDefaultLocation = !this.locationSettings.enableDefaultLocation;
  }

  onProvideLocationOutsideSelectionChange() {
    this.locationSettings.outsideVehicleLocation = !this.locationSettings.outsideVehicleLocation;
  }

  onSaveSettings() {
    console.log("Location settings::", this.locationSettings);
    this.updateLocationSettings(this.locationSettings);
  }

  onCancelSettings() {
    // console.log("cancel settings update");
    this.locationSettings = JSON.parse(JSON.stringify(this.locationSettingsCopy));
  }

  getLocationSettings() {
    this.utilService.showSpinner();
    this.apiService.getLocationSettings().then((data) => {
      this.utilService.hideSpinner();
      this.locationSettings = data;
      this.locationSettingsCopy = JSON.parse(JSON.stringify(data));
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getLocationSettings();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  updateLocationSettings(paylaod) {
    this.utilService.showSpinner();
    this.apiService.updateLocationSettings(paylaod).then((data) => {
      this.utilService.hideSpinner();
      this.locationSettings = data;
      this.locationSettingsCopy = JSON.parse(JSON.stringify(data));
      this.toast.showSuccess("Location settings updated successfully");
      document.getElementById("closeLocationSettings").click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.updateLocationSettings(paylaod);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

}
